module.exports = __webpack_public_path__ + "static/media/speakers7.a86383eb.jpg";